import { gql } from '@apollo/client';

export const GET_AUDIT_ITEM_FILTER_OPTIONS = gql`
  query GetAuditItemFilterOptions($communityId: ID!, $sessionId: ID!) {
    community(id: $communityId) {
      id
      auditSession(sessionId: $sessionId) {
        id
        auditItemFilterOptions {
          statuses
          labels
          severityLevels
          multipleDecisionsOptions
          violatesPolicyOptions
        }
      }
    }
  }
`;
